import { render, staticRenderFns } from "./workOrderDetail.vue?vue&type=template&id=b6fa6266&"
import script from "./workOrderDetail.vue?vue&type=script&lang=js&"
export * from "./workOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./workOrderDetail.vue?vue&type=style&index=0&id=b6fa6266&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports